import { SiteIdOverrideConfig } from "stores/wizard/config";

export const siteId70201: SiteIdOverrideConfig = {
  flight: {
    heading: {
      lobSubtitleBreakPoint: "medium",
      locTitleDesktopTextToken: "wizard.orbitz.label.flight",
      locSubtitleTextToken: "wizard.orbitz.subLabel.flight",
      differentiatedTitles: true,
    },
  },
  package: {
    heading: {
      lobSubtitleBreakPoint: "medium",
      locTitleDesktopTextToken: "wizard.orbitz.label.packages",
      locSubtitleTextToken: "wizard.orbitz.subLabel.packages",
      differentiatedTitles: true,
    },
  },
  hotel: {
    heading: {
      lobSubtitleBreakPoint: "medium",
      locTitleDesktopTextToken: "wizard.orbitz.label.hotel",
      locSubtitleTextToken: "wizard.orbitz.subLabel.hotel",
      differentiatedTitles: true,
    },
  },
};
